import React from 'react';
import { teaching_title } from 'components/langutils';
import { useData } from '../Data';

export function ResearchMenu() {
  const { current, type, lang, semesters, urls } = useData();
  const [current_semester, current_course] = current ?? [null, null];
  const sorted_semesters = [...Object.values(semesters.courses)]
  sorted_semesters.sort((a: any, b: any) => b.abc.localeCompare(a.abc));
  //sorted_fields.sort((a: any, b: any) => a.id < b.id);
  return (
    <React.Fragment>
      <img className="headImg2" src={urls.roofimg} width="100%" alt={current?.login ?? teaching_title(lang)} title={current?.login ?? teaching_title(lang)} />
      <div className="vlist">
        <ul>
          <li>
            <strong><a href="#">{teaching_title(lang)}</a></strong>
          </li>
          <li>
            <ul>
              { sorted_semesters.map((semester: any) => 
                <React.Fragment key={semester.id}>
                  <li>
                    <a href={`#${encodeURI(semester.id)}`}>
                      { (current_semester && current_semester === semester.id) && 
                        <strong>{ semester.name }</strong> || semester.name }
                    </a>
                  </li>
                  { current_semester && current_semester == semester.id && type &&
                    <li>
                      <ul>
                        { type.courses.map((course: any) =>
                          <li key={course.id}>
                            <a href={`#${encodeURI(semester.id)}:${encodeURI(course.id)}`}>
                              { (current_course && current_course === course.id) && 
                                <strong>{ course.title }</strong> || course.title }
                            </a>
                          </li>
                        )}
                      </ul>
                    </li>
                  }
                </React.Fragment>
              )}
            </ul>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
}
